import Videos from './Videos'

export default Videos
